// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__pCRr0","col":"styles_col__2UjZN","fulfillmentStatus":"styles_fulfillmentStatus__1O_jK","emailCol":"styles_emailCol__SXmMk"};